import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { getAge } from "@/utils/dateUtil";
import { DetailedCitizenBreastCancerProceduresIndicatorC7Data } from "@/services/esus/indicator/esf/c7/getDetailedCitizensBreastCancerProceduresIndicatorC7";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { ProceduresHistoryItem } from "./ProceduresHistoryItem";
import { ProceduresHistoryInfo } from "./ProceduresHistoryInfo";

type IndicatorEsfC7CitizenProceduresHistoryProps = {
	citizenWithProcedures: DetailedCitizenBreastCancerProceduresIndicatorC7Data;
};

export function IndicatorEsfC7CitizenProceduresHistory({
	citizenWithProcedures,
}: Readonly<IndicatorEsfC7CitizenProceduresHistoryProps>) {
	const indicatorEsfC7CitizenHistoryInfo = {
		fullName: citizenWithProcedures.fullName ? citizenWithProcedures.fullName : "N/A",
		birthdate: citizenWithProcedures.birthdate
			? dayjs(citizenWithProcedures.birthdate).format("DD/MM/YYYY")
			: "N/A",
		age: citizenWithProcedures.birthdate ? getAge(citizenWithProcedures.birthdate) : "N/A",
		document: citizenWithProcedures.cpf
			? formatIdentifier(citizenWithProcedures.cpf)
			: citizenWithProcedures.cns ?? "",
		motherName: citizenWithProcedures.motherName ?? "",
		phone: citizenWithProcedures.phone ? phoneFormat(citizenWithProcedures.phone) : "",
		address:
			addressConcat(
				citizenWithProcedures.street,
				citizenWithProcedures.houseNumber,
				citizenWithProcedures.neighborhood
			) ?? "",
	};

	return (
		<>
			<ProceduresHistoryInfo {...indicatorEsfC7CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Consultas"
				timeLineContents={(
					citizenWithProcedures.attendanceProcedureReqEvals ?? []
				).map<TimeLineContent>((attendance) => {
					return {
						content: <ProceduresHistoryItem attendanceProcedureReqEval={attendance} />,
						eventDate: attendance.date
							? dayjs(attendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
